/**
 * French translations
 */
import { common } from './fr/common';
import { dashboard } from './fr/dashboard';
import { vision2040 } from './fr/vision2040';
import { mentalHealth } from './fr/mentalHealth';
import { members } from './fr/members';
import { programs } from './fr/programs';
import { technology } from './fr/technology';
import { regional } from './fr/regional';
import { impact } from './fr/impact';
import { workforce } from './fr/workforce';
import { entrepreneurship } from './fr/entrepreneurship';
import { contributing } from './fr/contributing';
import { faq } from './fr/faq';
import { methodology } from './fr/methodology';
import { developmentCouncils } from './fr/developmentCouncils';
import { privacy } from './fr/privacy';
import { terms } from './fr/terms';
import { countryProfile } from './fr/countryProfile';

// NOTE: both Programs & Events and Technology modules used the same root key "programs".
// We deep-merge here to prevent one module from overwriting the other.
const { programs: programsLabels, ...programsRest } = programs;
const { programs: technologyProgramLabels, ...technologyRest } = technology;

export const fr = {
  ...common,
  ...dashboard,
  ...mentalHealth,
  ...regional,
  ...members,
  ...programsRest,
  ...impact,
  ...technologyRest,
  ...vision2040,
  ...workforce,
  ...entrepreneurship,
  ...contributing,
  ...methodology,
  ...developmentCouncils,
  ...countryProfile,
  privacy,
  terms,
  faq,
  programs: {
    ...programsLabels,
    ...technologyProgramLabels,
  },
} as const;

export type FrTranslations = typeof fr;

